import React from 'react';
import { MenuItem } from '@mui/material';
import { Link } from '@tanstack/react-router';

interface Props {
  hasPermissions?: boolean;
  onClick: () => void;
  pathName: string;
  title: string;
}

export const AvMenuItem: React.FC<Props> = ({ pathName, onClick, hasPermissions, title }) =>
  hasPermissions && (
    <MenuItem onClick={onClick} component={Link as any} to={pathName} params={prev => prev}>
      {title}
    </MenuItem>
  );
